import React, { useCallback } from "react"
import createStore from "@mborecki/react-create-store"
import SolidBodyBackgound, { SolidColorBackgroundState, useSetSolidColorBackground } from "./solid-color-background";
import FullImageBodyBackgound, { FullImageBackgroundState, useSetFullImageColorBackground } from "./full-image-background";
import PatternBackground, { PatternBackgroundState, useSetPatternBackground } from './pattern-background';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'BgTag': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
        }
    }
}
export enum BACKGROUND_TYPE {
    SOLID_COLOR,
    FULL_IMAGE,

    PATTERN
}

type BackgroundState = SolidColorBackgroundState | FullImageBackgroundState | PatternBackgroundState;

const reducer = (state: BackgroundState, action: { type: 'set' | 'reset', newState?: BackgroundState }) => {

    switch (action.type) {
        case 'set':
            return action.newState || state;

        case 'reset':
            return initBackgroudState;
    }
}

const initBackgroudState: BackgroundState = {
    type: BACKGROUND_TYPE.PATTERN,
    src: '/images/backgrounds/pattern_1.png'
}

const [
    BackgrondProdiver,
    useBackgroundDispacher,
    useBackgroundState
] = createStore(reducer, initBackgroudState);

const PageBackground: React.FunctionComponent = ({ children }) => {
    return (
        <BackgrondProdiver>
            <BackgroundSwitcher>
                {children}
            </BackgroundSwitcher>
        </BackgrondProdiver>)
}

const BackgroundSwitcher: React.FunctionComponent = ({ children }) => {

    const { type } = useBackgroundState();

    const BgTag = (() => {
        switch (type) {
            case BACKGROUND_TYPE.SOLID_COLOR:
                return SolidBodyBackgound;

            case BACKGROUND_TYPE.FULL_IMAGE:
                return FullImageBodyBackgound;

            case BACKGROUND_TYPE.PATTERN:
                return PatternBackground;
        }
    })()

    return (
        <BgTag>
            {children}
        </BgTag>
    )
}


export {
    useBackgroundDispacher,
    useBackgroundState
}

function useResetBackground() {
    const dispatch = useBackgroundDispacher();
    return useCallback(() => {
        dispatch({
            type: 'reset'
        })
    }, [dispatch])
}

export {
    useSetSolidColorBackground,
    useSetFullImageColorBackground,
    useSetPatternBackground,
    useResetBackground
}

export default PageBackground;
